import { render, staticRenderFns } from "./contactDetails.vue?vue&type=template&id=7e2e86ad"
import script from "./contactDetails.vue?vue&type=script&lang=js"
export * from "./contactDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports